/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var momentUtil = require('common/util/momentUtil');
var _ = require('underscore');

module.exports = function(formData) {
  var deferred = $.Deferred();
  var eventDetails = formData.eventDetails;
  var eventDocuments = eventDetails.eventDocuments;
  var venueDetails = formData.venueDetails;
  var organizationDetails = formData.organizationDetails;
  var presenters = formData.eventDetails.presenters || {};

  var startDateTimeStr = eventDetails.startDate + ' ' + eventDetails.startTime;

  var startDateTime = momentUtil.formatStr(
    startDateTimeStr,
    _.extend({}, momentUtil.defaultOutboundDateTimeConfig, { sourceFormat: 'MM/DD/YYYY hh:mm A' })
  );

  var endDateTimeStr = eventDetails.endDate + ' ' + eventDetails.endTime;

  var endDateTime = momentUtil.formatStr(
    endDateTimeStr,
    _.extend({}, momentUtil.defaultOutboundDateTimeConfig, { sourceFormat: 'MM/DD/YYYY hh:mm A' })
  );

  var eventJson = {
    subject: eventDetails.eventTitle,
    body: {
      contentType: 'Text',
      content: eventDetails.eventDescription
    },
    start: {
      dateTime: startDateTime,
      timeZone: 'Eastern Standard Time'
    },
    end: {
      dateTime: endDateTime,
      timeZone: 'Eastern Standard Time'
    },
    location: {
      displayName: venueDetails.venueName,
      address:
        eventDetails.eventFormatId === '1'
          ? {
              city: venueDetails.venueAddress.city,
              postalCode: venueDetails.venueAddress.postalCode,
              state: venueDetails.venueAddress.state,
              street: venueDetails.venueAddress.streetAddress
            }
          : {}
    }
  };

  var attendeesJson = {
    attendees: _.map(presenters, function(presenter) {
      return {
        emailAddress: {
          name: presenter.name,
          address: presenter.email
        }
      };
    })
  };

  $.soap({
    body: {
      CreateNewEvent: {
        $xmlns: 'http://dobs.pa.gov/co/event/bpm/1.0',
        EventTypeID: eventDetails.eventTypeId,
        Title: eventDetails.eventTitle,
        Description: eventDetails.eventDescription,
        StartDateTime: startDateTime,
        EndDateTime: endDateTime,
        Program1: eventDetails.program1Id,
        NumberOfPresentations: eventDetails.numberOfPresentations,
        IsThirdPartyEvent: eventDetails.isAARPEvent,
        ThirdPartyVolunteerID: eventDetails.aarpVolunteers,
        TargetAudienceID: eventDetails.targetAudienceId,
        IsRegRequired: eventDetails.isRegistrationRequired,
        RegDetails: eventDetails.registrationDetails,
        WhoPromoted: eventDetails.whoPromoted,
        HowPromoted: eventDetails.howPromoted,
        EventNotes: eventDetails.eventNotes,
        Attendance: eventDetails.attendance,
        EventFormatID: eventDetails.eventFormatId,
        Presenters: (function() {
          return {
            Presenter: _.map(presenters, function(presenter) {
              return {
                UserID: presenter.userId,
                IsTaskOwner: presenter.isTaskOwner
              };
            })
          };
        })(),
        VenueEntityID: venueDetails.venueId,
        VenueContactID: venueDetails.contactId,
        OrganizationEntityID: organizationDetails.organizationId,
        OrganizationContactID: organizationDetails.contactId,
        EventDetailsJSON: JSON.stringify(eventJson),
        AttendeesJSON: JSON.stringify(attendeesJson),
        EventDocuments: (function() {
          if (!eventDocuments || !eventDocuments.length) {
            return {};
          }
          return {
            Document: _.map(eventDocuments, function(eventDocument) {
              return {
                DocumentID: eventDocument.fileId
              };
            })
          };
        })()
      }
    },
    blueprint: {
      eventId: '$..EventID.__text'
    }
  })
    .done(function(response) {
      deferred.resolve(response);
    })
    .fail(function() {
      deferred.reject();
    });

  return deferred.promise();
};
